import formatDate from '~/helpers/formatDate';
import { PackageSessionResponse } from '~/types/api';
import staysStyles from '~/styles/bookingFlow/stays.module.css';
import { useId } from 'react';

type Props = {
  stay: PackageSessionResponse['prestays'][0];
  onChange: (packageId: number, selected: boolean) => void;
};

export default function Stay({
  stay,
  onChange,
}: Props) {
  const stayId = useId();

  const fromDateFormatted = formatDate(stay.start_date, 'd-m-Y');
  const toDateFormatted = formatDate(stay.end_date, 'd-m-Y');

  return (
    <div key={stay.package_id} className={staysStyles.staysItem}>
      <input
        type="checkbox"
        checked={stay.selected}
        id={stayId}
        onChange={(e) => onChange(stay.package_id, e.target.checked)}
        className={staysStyles.staysItemCheckbox}
      />

      <label htmlFor={stayId} className={staysStyles.staysItemLabel}>
        <strong className={staysStyles.staysItemTitle}>
          {stay.name}
        </strong>

        <div className={staysStyles.staysItemDate}>
          {fromDateFormatted}
          {' - '}
          {toDateFormatted}
        </div>
      </label>
    </div>
  );
}
